import axios from 'axios'
import ApiConfig from '@/api/config'

export function issueEsignSsoTicket(redirectTo = '/dashboard') {
  const token = JSON.parse(localStorage.getItem('token'))

  return axios.post(
    `${ApiConfig.basePath}/sso/esign/issue`,
    { redirect_to: redirectTo },
    {
      withCredentials: true,
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    }
  )
}
